import apiClient from "@/app/api/client";
import type { ListParams } from "@/shared/types/api";

export const weddingHallService = {
	list(params?: ListParams) {
		return apiClient.get("/wedding-halls", { params }).then((r) => r.data);
	},
	get(id: number) {
		return apiClient.get(`/wedding-halls/${id}`).then((r) => r.data);
	},
	create(data: Record<string, unknown>) {
		return apiClient.post("/wedding-halls", data).then((r) => r.data);
	},
	update(id: number, data: Record<string, unknown>) {
		return apiClient.patch(`/wedding-halls/${id}`, data).then((r) => r.data);
	},
	remove(id: number) {
		return apiClient.delete(`/wedding-halls/${id}`).then((r) => r.data);
	},
	uploadImage(id: number, file: File) {
		const fd = new FormData();
		fd.append("image", file);
		return apiClient
			.post(`/wedding-halls/${id}/image`, fd, {
				headers: { "Content-Type": "multipart/form-data" },
			})
			.then((r) => r.data);
	},
};
